export const EDGE_BUFFER: number = 20

export const MILLISECONDS_IN_DAY: number = 86400000
